/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiV1BootstrapParams,
  GetBootstrapResponse,
  ProblemDetails
} from '../model';

import { apiClient } from '../../lib/api-client';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getApiV1Bootstrap = (
    params?: GetApiV1BootstrapParams,
 signal?: AbortSignal
) => {


      return apiClient<GetBootstrapResponse | null>(
      {url: `/api/v1/bootstrap`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiV1BootstrapQueryKey = (params?: GetApiV1BootstrapParams,) => {
    return [
    `/api/v1/bootstrap`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiV1BootstrapQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1Bootstrap>>, TError = ProblemDetails | null>(params?: GetApiV1BootstrapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Bootstrap>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1BootstrapQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1Bootstrap>>> = ({ signal }) => getApiV1Bootstrap(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1Bootstrap>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1BootstrapQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1Bootstrap>>>
export type GetApiV1BootstrapQueryError = ProblemDetails | null


export function useGetApiV1Bootstrap<TData = Awaited<ReturnType<typeof getApiV1Bootstrap>>, TError = ProblemDetails | null>(
 params: undefined |  GetApiV1BootstrapParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Bootstrap>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Bootstrap>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Bootstrap>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Bootstrap<TData = Awaited<ReturnType<typeof getApiV1Bootstrap>>, TError = ProblemDetails | null>(
 params?: GetApiV1BootstrapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Bootstrap>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1Bootstrap>>,
          TError,
          Awaited<ReturnType<typeof getApiV1Bootstrap>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1Bootstrap<TData = Awaited<ReturnType<typeof getApiV1Bootstrap>>, TError = ProblemDetails | null>(
 params?: GetApiV1BootstrapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Bootstrap>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1Bootstrap<TData = Awaited<ReturnType<typeof getApiV1Bootstrap>>, TError = ProblemDetails | null>(
 params?: GetApiV1BootstrapParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1Bootstrap>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1BootstrapQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






